export type TeamView = 'day' | 'week'

/**
 * Een eigen sleutel naast 'uren.view': naar het team kijk je met een andere vraag dan
 * naar je eigen uren, dus de weergavekeuze hoort daar niet aan vast te zitten.
 */
const STORAGE_KEY = 'uren.team.view'

export function storedTeamView(): TeamView {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'day' ? 'day' : 'week'
  } catch {
    return 'week'
  }
}

export function rememberTeamView(view: TeamView): void {
  try {
    localStorage.setItem(STORAGE_KEY, view)
  } catch {
    /* private mode */
  }
}
